export function responsibleService(http) {
    const serviceName = "Responsible";

    return {
        getCartable:(userId,pageNumber,pageSize,sortBy,cartableTypeId,filters) => {

            const newSortBy=(sortBy||[]).map(item=>( {member:item.id,sortDirection:item.desc?"Descending":"Ascending"}))

            // const newfilter= Object.keys(filters).map(key => {
            //     return {
            //         member:key,
            //         operator:filters[key].operator,
            //         value: filters[key].columnType=="number"?Number(filters[key].value):filters[key].value
            //     };
            //   });
            // const filter= cartableTypeId==1
            // ?{
            //     logic:"And",
            //     filters:[
            //         ...newfilter,
            //         {
            //             "member": "IsDone",
            //             "operator": "IsEqualTo",
            //             "value": "false"
            //         },
            //         {
            //             "logic":"Or",
            //             "filters":[
            //             {
            //                 "member": "UserId",
            //                 "operator": "IsEqualTo",
            //                 "value": "619C1E32-63E1-4EC0-A67B-488F44EC402C"
            //             }]
            //         }
            //     ]
            // }
            // :newfilter.length>0 
            //     ?{
            //         logic:"And",
            //         filters:newfilter
            //     }
            //     :null;

            const filter=filters;

            const data = {
                    user:{
                        id:userId
                    },
                    cartableTypeId,
                    dataAttribute:{
                        page:pageNumber,
                        pageSize,
                        sorts:newSortBy.lenght==0?[{member:"AssignId",sortDirection:"Descending"}]:newSortBy,
                        filter:filter
                    }
            };
            return http.post(serviceName + "/GetCartable",data);
        },
        getScheduledWorkload:(fromDate,toDate,userId)=>{
            return http.get(`${serviceName}/GetScheduledWorkload?fromDate=${fromDate}&toDate=${toDate}&userId=${userId}`);
        },
        getEmployeeNotAssignWithWorkload:(disciplineId,employmentCostCenterCode,employmentCostCenterSubCode,dayCount,subDisciplineId,projectId)=>{
            const data={
                disciplineId,
                //startDate,
                //dueDate,
                employmentCostCenterCode,
                employmentCostCenterSubCode,
                dayCount,
                projectId,
                subDisciplineId
            };

            return http.post(serviceName + "/GetEmployeeNotAssignWithWorkload",data);
        },
        getResponsibleAssigned:(keyId,dayCount)=>{
            const data={
                keyId,
                dayCount
            };

            return http.post(serviceName + "/GetResponsibleAssigned",data);
        },
        getResponsibleAssignedWithoutWorkload:(keyId)=>{
            // const data={
            //     keyId,
            //     dayCount
            // };

            return http.get(`${serviceName}/GetEmployeesWithoutWorkload?keyId=${keyId}`);
        },
        getDisciplineSupervisorsByDisciplineIds:(disciplineIds)=>{
            const _disciplineIds=disciplineIds.map(a=>`disciplineIds=${a}`).join('&');
            return http.get(serviceName + `/GetDisciplineSupervisorsByDisciplineIds?${_disciplineIds}`);
        },
        getDisciplineSupervisors:(disciplineId)=>{
            return http.get(serviceName + `/GetDisciplineSupervisors?disciplineId=${disciplineId}`);
        },
        getConsumedManHours:(assignId)=>{
            debugger;
            return http.get(`${serviceName}/GetConsumedManHours?assignId=${assignId}`)
        },
        addCousumeMahHour:(actorUser,formData,files,activityTypeId, uniqueId,workflowCategoryType,selectedUploadedFiles)=>{
            const data={
                user:actorUser,
                ConsumedManHour:formData,
                files,
                activityTypeId,
                uniqueId,
                workflowCategoryType,
                selectedUploadedFiles
            };

            return http.post(serviceName + "/AddConsumeManHour",data);
        },
        updateCousumeMahHour:(actorUser,formData,files,activityTypeId, uniqueId,workflowCategoryType,selectedUploadedFiles)=>{
            const data={
                user:actorUser,
                ConsumedManHour:formData,
                files,
                activityTypeId,
                uniqueId,
                workflowCategoryType,
                selectedUploadedFiles
            };

            return http.post(serviceName + "/UpdateConsumeManHour",data);
        },
        returnCousumeMahHour:(actorUser,formData,files,activityTypeId, uniqueId,workflowCategoryType)=>{
            const data={
                user:actorUser,
                ConsumedManHour:formData,
                files,
                activityTypeId,
                uniqueId,
                workflowCategoryType
            };

            return http.post(serviceName + "/ReturnConsumeManHour",data);
        },
        deleteManHourConsume:(actorUser,assignId,consumedManHourId,activityId,activityTypeId)=>{
            const data={
                user:actorUser,
                assignId,
                consumedManHourId,
                activityId,
                activityTypeId
            };

            return http.post(serviceName + "/DeleteConsumeManHour",data)
        },
        getFiles:(id)=>{
            return http.get(serviceName+`/GetFiles?id=${id}`);
        },
        deleteFile:(fileManagementId,fileId)=>{
            const data={
                fileManagementId,
                fileId
            }
            return http.post(`${serviceName}/DeleteFile`,data);
        },
        getAssignHistory:(keyId)=>{
            return http.get(`${serviceName}/GetAssignHistory?keyId=${keyId}`);
        },
        getTotalWork:(userId,date)=>{
            return http.get(`${serviceName}/GetTotalWork?userId=${userId}&date=${date}`);
        },
        getTotalWorkAndTotalConsumed:(userId,date)=>{
            return http.get(`${serviceName}/GetTotalWorkAndTotalConsumed?userId=${userId}&date=${date}`);
        },
        getTotalWorkAndTotalConsumedAndTimesheet:(userId,date)=>{
            return http.get(`${serviceName}/GetTotalWorkAndTotalConsumedAndTimesheet?userId=${userId}&date=${date}`);
        },
        getTotalConsumed:(userId,date)=>{
            return http.get(`${serviceName}/GetTotalConsumed?userId=${userId}&date=${date}`);
        },
        getRangeWorkload(userId,fromDate,toDate){
            return http.get(`${serviceName}/GetRangeWorkload?userId=${userId}&fromdate=${fromDate}&todate=${toDate}`); 
        }

    }
}